module.exports = __webpack_public_path__ + "static/media/slider-2.77e1475a.png";